import { YieldPerTimespan } from "types/YieldPerTimespan";
import { ActionType, getType } from "typesafe-actions";
import * as yieldPerTimespanActions from "./yieldPerTimespanActions";

export type YieldPerTimespanState = {
  [K in yieldPerTimespanActions.YieldPerTimespanContentType]?: {
    loading?: boolean;
    data?: YieldPerTimespan[];
    error?: string;
  };
};

export type YieldPerTimespanActions = ActionType<typeof yieldPerTimespanActions>;

export default function yieldPerTimespan(
  state: YieldPerTimespanState = {},
  action: YieldPerTimespanActions
) {
  switch (action.type) {
    case getType(yieldPerTimespanActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(yieldPerTimespanActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(yieldPerTimespanActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
